var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("select-dialog", {
    ref: "selectDialog",
    attrs: {
      title: _vm.$t("CargoMsg.Cargo_SelectOperationInstruction"),
      "row-data": _vm.rowData,
      "column-defs": _vm.columnDefs,
      "filter-keys": ["instructionName"],
      value: _vm.platformInstructionUuid,
      "event-name": _vm.eventName,
      "filter-label": _vm.$t("CargoMsg.Cargo_InstructionName"),
      "display-name-field": "instructionName"
    },
    on: { change: _vm.changeTrigger }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }